/**
 * DonationTypeCard Component
 *
 * Displays a Service type with image, name, and description
 */

import { ServiceType } from '@/types/service.types';
import clsx from 'clsx';

interface ServiceTypeCardProps {
  serviceType: ServiceType;
  onSelect: (serviceType: ServiceType) => void;
  selected?: boolean;
}

export function ServiceTypeCard({ serviceType, onSelect, selected }: ServiceTypeCardProps) {
  return (
    <button
      onClick={() => onSelect(serviceType)}
      className={clsx(
        'group relative overflow-hidden rounded-xl border-2 transition-all duration-200 text-left',
        'hover:shadow-lg hover:scale-105 flex flex-col h-full',
        selected
          ? 'border-emerald-800 shadow-md'
          : 'border-gray-200 bg-white hover:border-emerald-300'
      )}
    >
      {/* Title with background at the top */}
      <div className="relative w-full bg-emerald-800 px-4 py-3">
        <h3 className="text-xl font-bold text-white text-center">
          {serviceType.detailedTextHeader ||
            serviceType.shortName ||
            `Service Type ${serviceType.donationType}`}
        </h3>
        {selected && (
          <div className="absolute right-3 top-1/2 -translate-y-1/2 rounded-full bg-white p-1.5 shadow-lg">
            <svg className="h-5 w-5 text-emerald-800" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        )}
      </div>

      {/* Card content */}
      <div className="p-4 bg-white flex-1">
        <p className="text-center text-gray-700">{serviceType.detailedText}</p>
      </div>
    </button>
  );
}
